import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import regionConfig, { REGION } from '../config/regionConfig';

// Importações dos namespaces pt-BR
import commonPtBR from './locales/pt-BR/common.json';
import navigationPtBR from './locales/pt-BR/navigation.json';
import ordersPtBR from './locales/pt-BR/orders.json';
import pdvPtBR from './locales/pt-BR/pdv.json';
import authPtBR from './locales/pt-BR/auth.json';
import whatsappPtBR from './locales/pt-BR/whatsapp.json';
import adminMenuRequestsPtBR from './locales/pt-BR/adminMenuRequests.json';
import printerPtBR from './locales/pt-BR/printer.json';
import plansAdminPtBR from './locales/pt-BR/plansAdmin.json';
import paymentMethodsPtBR from './locales/pt-BR/paymentMethods.json';
import botConfigPtBR from './locales/pt-BR/botConfig.json';
import menuImportPtBR from './locales/pt-BR/menuImport.json';
import subscriptionPtBR from './locales/pt-BR/subscription.json';
import storeInfoPtBR from './locales/pt-BR/storeInfo.json';
import cardapioPtBR from './locales/pt-BR/cardapio.json';
import teamPtBR from './locales/pt-BR/team.json';
import onboardingPtBR from './locales/pt-BR/onboarding.json';
import cashRegisterPtBR from './locales/pt-BR/cashRegister.json';
import estoquePtBR from './locales/pt-BR/estoque.json';
import entregadoresPtBR from './locales/pt-BR/entregadores.json';
import categoriasPtBR from './locales/pt-BR/categorias.json';
import complementosPtBR from './locales/pt-BR/complementos.json';
import reportsPtBR from './locales/pt-BR/reports.json';
import mesasPtBR from './locales/pt-BR/mesas.json';
import supportPrivacyPtBR from './locales/pt-BR/supportPrivacy.json';
import supportChatPtBR from './locales/pt-BR/supportChat.json';

// Importações dos namespaces en-US
import commonEnUS from './locales/en-US/common.json';
import navigationEnUS from './locales/en-US/navigation.json';
import ordersEnUS from './locales/en-US/orders.json';
import pdvEnUS from './locales/en-US/pdv.json';
import authEnUS from './locales/en-US/auth.json';
import whatsappEnUS from './locales/en-US/whatsapp.json';
import adminMenuRequestsEnUS from './locales/en-US/adminMenuRequests.json';
import printerEnUS from './locales/en-US/printer.json';
import plansAdminEnUS from './locales/en-US/plansAdmin.json';
import paymentMethodsEnUS from './locales/en-US/paymentMethods.json';
import botConfigEnUS from './locales/en-US/botConfig.json';
import menuImportEnUS from './locales/en-US/menuImport.json';
import subscriptionEnUS from './locales/en-US/subscription.json';
import storeInfoEnUS from './locales/en-US/storeInfo.json';
import cardapioEnUS from './locales/en-US/cardapio.json';
import teamEnUS from './locales/en-US/team.json';
import onboardingEnUS from './locales/en-US/onboarding.json';
import cashRegisterEnUS from './locales/en-US/cashRegister.json';
import estoqueEnUS from './locales/en-US/estoque.json';
import entregadoresEnUS from './locales/en-US/entregadores.json';
import categoriasEnUS from './locales/en-US/categorias.json';
import complementosEnUS from './locales/en-US/complementos.json';
import reportsEnUS from './locales/en-US/reports.json';
import mesasEnUS from './locales/en-US/mesas.json';
import supportPrivacyEnUS from './locales/en-US/supportPrivacy.json';
import supportChatEnUS from './locales/en-US/supportChat.json';

const resources = {
  'pt-BR': {
    common: commonPtBR,
    navigation: navigationPtBR,
    orders: ordersPtBR,
    pdv: pdvPtBR,
    auth: authPtBR,
    whatsapp: whatsappPtBR,
    adminMenuRequests: adminMenuRequestsPtBR,
    printer: printerPtBR,
    plansAdmin: plansAdminPtBR,
    paymentMethods: paymentMethodsPtBR,
    botConfig: botConfigPtBR,
    menuImport: menuImportPtBR,
    subscription: subscriptionPtBR,
    storeInfo: storeInfoPtBR,
    cardapio: cardapioPtBR,
    team: teamPtBR,
    onboarding: onboardingPtBR,
    cashRegister: cashRegisterPtBR,
    estoque: estoquePtBR,
    entregadores: entregadoresPtBR,
    categorias: categoriasPtBR,
    complementos: complementosPtBR,
    reports: reportsPtBR,
    mesas: mesasPtBR,
    supportPrivacy: supportPrivacyPtBR,
    supportChat: supportChatPtBR,
  },
  'en-US': {
    common: commonEnUS,
    navigation: navigationEnUS,
    orders: ordersEnUS,
    pdv: pdvEnUS,
    auth: authEnUS,
    whatsapp: whatsappEnUS,
    adminMenuRequests: adminMenuRequestsEnUS,
    printer: printerEnUS,
    plansAdmin: plansAdminEnUS,
    paymentMethods: paymentMethodsEnUS,
    botConfig: botConfigEnUS,
    menuImport: menuImportEnUS,
    subscription: subscriptionEnUS,
    storeInfo: storeInfoEnUS,
    cardapio: cardapioEnUS,
    team: teamEnUS,
    onboarding: onboardingEnUS,
    cashRegister: cashRegisterEnUS,
    estoque: estoqueEnUS,
    entregadores: entregadoresEnUS,
    categorias: categoriasEnUS,
    complementos: complementosEnUS,
    reports: reportsEnUS,
    mesas: mesasEnUS,
    supportPrivacy: supportPrivacyEnUS,
    supportChat: supportChatEnUS,
  },
};

// Lista de idiomas suportados
export const supportedLanguages = [
  { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
  { code: 'en-US', name: 'English (US)', flag: '🇺🇸' },
];

// Migrate old localStorage key to new one (one-time)
const oldLang = localStorage.getItem('pedeja_language');
if (oldLang && !localStorage.getItem('app_language')) {
  localStorage.setItem('app_language', oldLang);
  localStorage.removeItem('pedeja_language');
}

// A preferencia de idioma vale apenas para a REGIAO em que foi feita.
//
// A versao anterior gravava o default da regiao na PRIMEIRA visita e nunca
// mais revisava: quem abriu o app quando a origem servia 'br' ficava com
// pt-BR gravado para sempre e, ao passar a servir 'lb', continuava em
// portugues. Reescrever (em vez de apagar) e proposital -- o LanguageDetector
// esta configurado com order ['localStorage', 'navigator', ...], entao apagar
// a chave entregaria a decisao ao idioma do navegador, que e justamente o que
// este bloco existe para impedir.
const CHAVE_REGIAO = 'app_language_region';
if (localStorage.getItem(CHAVE_REGIAO) !== REGION) {
  localStorage.setItem('app_language', regionConfig.locale.default);
  localStorage.setItem(CHAVE_REGIAO, REGION);
}

// Configuração do i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: regionConfig.locale.fallback,
    defaultNS: 'common',
    ns: ['common', 'navigation', 'orders', 'pdv', 'auth', 'whatsapp', 'adminMenuRequests', 'printer', 'plansAdmin', 'paymentMethods', 'botConfig', 'menuImport', 'subscription', 'storeInfo', 'cardapio', 'team', 'onboarding', 'cashRegister', 'estoque', 'entregadores', 'categorias', 'complementos', 'reports', 'mesas', 'supportPrivacy', 'supportChat'],

    interpolation: {
      escapeValue: false, // React já faz escape por padrão
      defaultVariables: {
        brandName: regionConfig.brand.name,
        brandDomain: regionConfig.brand.domain,
        botName: regionConfig.brand.botName,
        setupFile: regionConfig.brand.printSetupFile,
      },
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_language',
    },

    react: {
      useSuspense: false, // Compatibilidade com loading states existentes
    },
  });

// Helper para trocar idioma
export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem('app_language', lang);
  // Carimba a regiao junto: sem isso a escolha seria sobrescrita no proximo boot.
  localStorage.setItem(CHAVE_REGIAO, REGION);
};

// Helper para obter idioma atual
export const getCurrentLanguage = () => i18n.language || regionConfig.locale.default;

export default i18n;
